import SectionBox from '@components/SectionBox';
import { useEffect, useState } from 'react';

interface TabsSectionBoxProps {
  sections: unknown[];
  locale: string;
  labels: string[];
  backgroundColorHeader: string;
  onTabSelect?: (tab: string) => void;
  activeTab: string;
}

export default function TabsSectionBox({
  sections,
  locale,
  labels,
  backgroundColorHeader,
  onTabSelect,
  activeTab,
}: TabsSectionBoxProps) {
  const [ sectionBoxIndex, setSectionBoxIndex ] = useState(0);

  useEffect(() => {
    // If no active tab is selected yet, default to the first tab
    const index = activeTab ? labels.findIndex((label) => label === activeTab) : 0;
    setSectionBoxIndex(index >= 0 ? index : 0);
  }, [ activeTab, labels ]);

  const handleTabClick = (label: string) => {
    if (onTabSelect) {
      onTabSelect(label);
    }
  };

  return (
    <>
      <div className={ `relative w-full overflow-x-auto pt-5 pb-2 mt-1 md:mt-2 md:pt-7 px-4 rounded-t-[1rem] md:rounded-t-[1.5rem] ${ backgroundColorHeader }` }>
        <div className='flex gap-2 md:gap-4 justify-start md:justify-center min-w-fit mx-auto flex-wrap rounded-full'>
          {labels.map((label) => (
            <button
              key={ label }
              onClick={ () => handleTabClick(label) }
              className={ `
                whitespace-nowrap
                px-4 md:px-6
                py-2 md:py-2.5
                text-body-md md:text-body-lg
                transition-all duration-200
                min-w-[100px] md:min-w-[140px]
                rounded-full
                ${ activeTab === label
              ? 'bg-primary text-white text-body-md--semibold md:text-body-lg--semibold shadow-sm'
              : 'bg-white text-primary-800 hover:text-primary-600 border border-primary-800 hover:border-primary-600'
            }
              ` }
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      <SectionBox
        sections={ sections[sectionBoxIndex] }
        locale={ locale }
        activeTab={ activeTab }
      />
    </>
  );
}
